import { ActionTree } from "vuex"
import { Booking, BookingFilter, BookingResource, BookingsFilter, BookingsState } from "~/store/bookings/bookings.types"
import { RootState } from "~/store/store.types"
import { RequestParameters } from "~/utils/SohoApi/SohoApi"
import { SohoModel } from "~/constants/SohoModel"
import { setIncludedResources } from "~/utils/store"

export const BOOKING_REQUEST_TIMEOUT = 30000
export const BOOKING_CREATION_TIMEOUT = 20000


const actions: ActionTree<BookingsState, RootState> = {
  async fetchBookings ({ commit }, params: RequestParameters<Booking, BookingsFilter> = {}) {
    const { data, included, meta } = await this.$sohoApi.get<BookingResource>(SohoModel.Booking, params, { timeout: BOOKING_REQUEST_TIMEOUT })

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_BOOKINGS", { params, data })
    }
    return { data, included, meta }
  },

  async fetchBooking ({ commit }, params: RequestParameters<Booking, BookingFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<BookingResource>(`${SohoModel.Booking}/${params.id}`, {
      include: ['room', 'rate_plan']
    })

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_BOOKING", data)
    }

    // This is used for polling before going to confirmation page
    return data
  },

  async createBooking ({ commit }, params: Booking) {
    // @ts-ignore
    const { data } = await this.$sohoApi.post<Booking>(SohoModel.Booking, { type: SohoModel.Booking, ...params }, { timeout: BOOKING_CREATION_TIMEOUT })

    return data
  },

  async updateBooking ({ commit }, params: Partial<Booking>) {
    const { data } = await this.$sohoApi.patch<Partial<Booking>>(
      SohoModel.Booking, 
      params, 
      { 
        timeout: BOOKING_CREATION_TIMEOUT
      },
      false
    )

    commit("SET_BOOKING", { data })
    return data
  },

  // This call sets booking status to cancelled and fetches the updated booking
  async deleteBooking ({ commit, dispatch }, id: string) {
    await this.$sohoApi.delete<Booking>(SohoModel.Booking, id)
    await dispatch('fetchBooking', { id })
  }
}

export default actions
